<script>
    import { createEventDispatcher, onMount } from "svelte";
    import { navigate } from 'svelte-routing';
    import { currentUser } from '../stores/currentUser';
    import firebase from '../firebase';

    export let title = '';
    
    const dispatch = createEventDispatcher();
	const handleKeydown = event => {
        if (event.keyCode == 13) {
            dispatch("enterPressed");
        }
    };

    firebase.auth().signOut();
</script>

<svelte:head>
	<title>{title ? `${title} - ` : ''}Eastwood 45</title>
</svelte:head>

<svelte:window on:keydown={handleKeydown}/>

<slot />